module.exports = __webpack_public_path__ + "img/rocket-flight.7c0bdcac.svg";